import {QuotationSchema, QuotationUser} from "@feature/quotations";
import {UserData} from "../types";

export const getQuotationUsers = (
  quotation: QuotationSchema,
): Record<QuotationUser, UserData> => {
  const base = {
    agent: {
      id: quotation.id_agent,
      name: quotation.des_agent,
    },
    resale: {
      id: quotation.id_resale,
      name: quotation.des_resale,
    },
    enterprise: {
      id: quotation.id_enterprise,
      name: quotation.des_enterprise,
    },
  };
  return Object.entries(base).reduce(
    (acc, [key, val]) => {
      const fixed =
        val.id !== null
        && quotation.r_perm.indexOf(`user_${val.id}`) !== -1;
      return {
        ...acc,
        [key]: {...val, fixed},
      }
    },
    {} as Record<QuotationUser, UserData>,
  );
}